var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangerline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 36,
    viewBox: "0 0 8 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 36H8V28.7873H0V36ZM0 25.2443H8V0H0V25.2443Z",
    fill: "#F22800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerline);
export default __webpack_public_path__ + "static/media/dangerline.4ef29416afa092f5fb956d8a3e6ed400.svg";
export { ForwardRef as ReactComponent };